import React from "react";
import { Link } from "react-router-dom";
import { canAccessWorkspace, getAccessDeniedMessage } from "../../util/accessControl";
import useAuth from "../../hooks/useAuth";

const AdminLayout = ({ children }) => {
  const { user } = useAuth();

  const allowed = canAccessWorkspace(user);

  if (!allowed) {
    return (
      <div className="min-h-screen bg-slate-50 px-4 pt-24 pb-10 font-inter">
        <div className="mx-auto max-w-xl rounded-3xl border border-rose-200 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-50 text-rose-600">
            <svg className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="mt-4 text-xl font-semibold text-slate-950">Access denied</h1>
          <p className="mt-2 text-sm text-slate-600">{getAccessDeniedMessage()}</p>
          <div className="mt-6 flex justify-center gap-3">
            <Link to="/home" className="inline-flex items-center rounded-xl bg-[#096dea] px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0959bb]">
              Go home
            </Link>
            <Link to="/login" className="inline-flex items-center rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50">
              Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 font-inter pt-16">
      <main className="relative min-w-0 w-full px-4 py-4 sm:px-6 lg:px-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;